module.exports = __webpack_public_path__ + "img/achievement3.4e698f00.jpg";